import React, { useEffect, useState } from "react";

export default React.forwardRef((props, ref) => {
    const [hover, setHover] = useState(!!props.startHover);

    useEffect(() => {
        setHover(!!props.startHover);
    }, [props.startHover]);

    const hoverStyle = hover && props.hoverStyle ? props.hoverStyle : {};

    const estilo = { ...props.style, ...hoverStyle };

    if (!props.forceBorder && (props.forceBoxShadow || (!props.solid && props.type !== "light"))) {
        estilo.border = "none";
        estilo.boxShadow = `0px 0px 1px 2px ${hover && !props.disabled ? "transparent" : "#2222"}`;
        estilo.filter = "brightness(1.01)";
    }

    const estiloIcone = props.iconStyle || {};

    const icones = props.icons || [];
    return (
        <button
            ref={ref}
            onMouseEnter={() => {
                setHover(true);
                if (props.eventHover) props.eventHover();
            }}
            onMouseLeave={() => {
                setHover(false);
                if (props.eventHover) props.eventHover();
            }}
            title={props.title}
            type={props.submit ? "submit" : "button"}
            className={`btn ${hover ? "active" : ""}  ${hover || props.solid || props.type === "light" ? "" : "btn-light"} ${props.flex ? "" : "btn-block"} btn-lg  btn${props.solid ? "" : "-outline"}-${props.type} ${props.disabled ? "disabled" : null}`}
            onClick={() => (props.disabled || !props.event ? () => {} : props.event())}
            disabled={props.disabled}
            style={estilo}
        >
            {props.icon ? (
                <i className={props.icon || ""} style={{ marginRight: props.text ? 4 : 0, ...estiloIcone }}></i>
            ) : (
                icones.map((icon, i) => <i key={i} className={`${icon.className}`} style={{ fontSize: icon.fontSize, marginLeft: i == 0 ? 0 : 2 }}></i>)
            )}
            {props.text}
        </button>
    );
});

/*
primary
secondary
success
danger
warning
info
light
dark
link
*/
